import { render, staticRenderFns } from "./performanceFeePayment.vue?vue&type=template&id=1609e833&scoped=true"
import script from "./performanceFeePayment.vue?vue&type=script&lang=js"
export * from "./performanceFeePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1609e833",
  null
  
)

export default component.exports